import React, { useMemo } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { Paper, TableContainer } from '@mui/material';
import { useSelector } from 'react-redux';
import VirtualizedTable from '../../virtualized-table';
import TableHoverTooltip from '../../table-hover-tooltip';
import { VirtualTableHeadCell } from '../../virtualized-table/types';
import { AppState } from '../../../store';

const BulkDeviceManagementTable = ({
  storageString,
  tableContainer,
  id,
  columnVisibility,
  columnOrder,
  headerColumns,
  sortableAccessors,
  onRowSelection,
  data,
}: {
  headerColumns: VirtualTableHeadCell[];
  sortableAccessors: { [key: string]: boolean };
  storageString: string;
  tableContainer: React.RefObject<HTMLElement>;
  id?: string;
  columnVisibility: string[];
  columnOrder: string[];
  onRowSelection?: Function;
  data: any[] | undefined;
}) => {
  const columnWidths = window.localStorage.getItem(`${storageString}-column-widths`);
  const loading = useSelector((state: AppState) => state.bulkFlash.loading);
  const dataMemoized = useMemo(() => data || [], [data]);
  const columns = useMemo(
    () =>
      headerColumns.map((cell) => {
        const widths = columnWidths && JSON.parse(columnWidths);
        const width = widths && widths[cell.accessor];
        if (widths && width) return { ...cell, width };
        return cell;
      }),
    [columnWidths, headerColumns],
  );

  const onColumnWidthsChange = (widths: { [key: string]: boolean }) => {
    localStorage.setItem(`${storageString}-column-widths`, JSON.stringify(widths));
  };
  const processRowSelection = (rowNumberObject: { [key: string]: boolean }[]) => {
    if (data && onRowSelection) {
      const selectedRows = Object.keys(rowNumberObject).map(
        (key: string) => dataMemoized[Number.parseInt(key, 10)],
      );
      onRowSelection(selectedRows);
    }
  };

  return (
    <Paper style={{ height: '100%', width: 'inherit', marginBottom: '24px', overflow: 'hidden' }}>
      {tableContainer && <TableHoverTooltip containerReference={tableContainer} />}
      <CssBaseline>
        <TableContainer id={id}>
          <VirtualizedTable
            tableContainer={tableContainer}
            columns={columns}
            data={dataMemoized}
            useFrontEndSorting
            itemCount={dataMemoized.length}
            onColumnWidthsChange={onColumnWidthsChange}
            onRowSelection={onRowSelection && processRowSelection}
            sortableAccessors={sortableAccessors}
            columnOrder={columnOrder}
            columnVisibility={columnVisibility}
            loading={loading}
          />
        </TableContainer>
      </CssBaseline>
    </Paper>
  );
};

export default BulkDeviceManagementTable;
